import { createListenerMiddleware } from '@reduxjs/toolkit';
import { RootState, AppDispatch } from '..';
import { creatorActions } from '../slices/creatorSlice';
import ConfigurationRenderer from '@/renderer/ConfigurationRenderer';

const renderer = ConfigurationRenderer.getInstance();

export const creatorMiddleware = createListenerMiddleware();

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.initialize,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
		if (payload.project || payload.projectTemplate) return;

		listenerApi.dispatch(creatorActions.setMaxProjectHeight());
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.selectAttributeValue,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();
		await listenerApi.delay(250);

		listenerApi.dispatch(creatorActions.setVariationsAndArticles());
		listenerApi.dispatch(creatorActions.setMaxProjectHeight());
		listenerApi.dispatch(creatorActions.setRollerBoxConfiguration());

		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setDimensions,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();
		await listenerApi.delay(250);

		if (payload.height) {
			listenerApi.dispatch(creatorActions.setRollerBoxConfiguration());
			return;
		}

		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setSegmentsQuantity,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.updateSegmentJoint,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setWingDivisionType,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setSegmentWidth,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();

		await listenerApi.delay(100);

		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.updateWindow,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();

		await listenerApi.delay(100);

		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.updateWing,
	effect: ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setWingWidth,
	effect: async ({ payload }, listenerApi) => {
		listenerApi.cancelActiveListeners();
		await listenerApi.delay(100);

		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setWingsQuantity,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setRollerBoxConfiguration,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.setMontageType,
	effect: async ({ payload }, listenerApi) => {
		renderer.manager.setFromCreatorState(listenerApi.getState().creator);
	},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.resetCreator,
	effect: async ({ payload }, listenerApi) => {
		renderer.reset();
	},
});
